export default __webpack_public_path__ + "static/media/warning.ff1ba873.mp3";